import React, { Component } from 'react';
import moment from 'moment';
import _memoize from 'lodash.memoize';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import { Text, FormModal, Input, Button, Icon } from '../../../ui-kit';
import AssetPreview from '../../AssetPreview';
import Loading from './Loading';
import FileInfo from './FileInfo';
import { getAsset } from '../queries';
import makeRequest from '../../../common/utils/makeRequest';
import { DownloadAssetMenu } from '../../DownloadAssetMenu';
import '../styles/_manage-asset-modal.scss';

































class ManageAssetModal extends Component {
  updateInputField = _memoize((fieldName) => (result) => {
    this.setState({ [fieldName]: getStringValueFromGenericInput(result) });
  });

  static defaultProps = {
    readOnly: true
  };

  constructor(props) {
    super(props);

    this.state = { canUpdate: false, isLoading: true };
  }

  updateTags = (tags) => {
    this.setState({ tags });
  };

  componentDidUpdate = async (prevProps) => {
    const { isVisible: prevIsVisible } = prevProps;
    const { isVisible } = this.props;
    const isUpdatingVisibilityToTrue = !prevIsVisible && isVisible;

    if (!isUpdatingVisibilityToTrue) {return;}

    this.resetState();

    await this.fetchAsset();
  };

  componentDidMount = () => {
    const { isVisible } = this.props;

    if (!isVisible) {return;}

    this.fetchAsset();
  };

  handleSave = async () => {
    const { assetId, updateAsset, onSave } = this.props;
    const { title, description, altText, tags } = this.state;
    const { data, error } = await updateAsset(assetId, { title, description, altText, tags });

    if (!data || !data.updateAsset || error || !onSave) {return;}

    onSave(data);
  };

  canUpdate = (asset) => {
    if (!asset) {return false;}

    return asset.permissions && asset.permissions.includes('UPDATE') || false;
  };

  getDate = (createdAt) => `${moment(createdAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('Do MMM YYYY [at] HH:mm[]A')}`;

  fetchAsset = async () => {
    const { assetId, apiClient } = this.props;
    const requestParams = {
      query: getAsset,
      variables: {
        assetId
      },
      context: {
        module: 'assets'
      },
      fetchPolicy: 'network-only'
    };
    const { data, error } = await makeRequest({
      request: apiClient.query,
      requestParams,
      showErrorNotification: true
    });

    if (!data || !data.getAsset || error) {
      return void this.setState({ error, isLoading: false });
    }

    const { getAsset: asset } = data;
    const { title = '', description = '', tags = '', altText = '' } = asset;

    this.setState({
      isLoading: false,
      asset,
      title,
      description,
      altText,
      canUpdate: this.canUpdate(asset),
      tags
    });
  };

  resetState = () => {
    this.setState({
      isLoading: true,
      asset: void 0,
      title: '',
      description: '',
      tags: '',
      canUpdate: false,
      altText: ''
    });
  };

  formatFileSize = (sizeInBytes) => {
    if (!sizeInBytes || sizeInBytes === 0) return 'Unknown size';

    const kb = sizeInBytes / 1024;
    const mb = kb / 1024;

    if (mb >= 1) {
      return `${mb.toFixed(1)}MB`;
    }
    return `${Math.round(kb)}KB`;
  };

  getModalContent = () => {
    const { asset, error, isLoading, canUpdate } = this.state;
    const { isVisible, readOnly } = this.props;
    const disableInput = !canUpdate && (Boolean(error) || readOnly);

    if (isLoading) {
      return <Loading />;
    }

    const {
      filename,
      altText,
      title,
      description,
      createdAt,
      createdByUser,
      metaData
    } = asset || {};

    let fileType = 'Unknown';
    let fileSize = 'Unknown size';

    if (metaData) {
      try {
        const parsedMetadata = typeof metaData === 'string' ? JSON.parse(metaData) : metaData;
        fileType = parsedMetadata.type || 'Unknown';
        fileSize = this.formatFileSize(parsedMetadata.size);
      } catch (e) {
        console.warn('Error parsing metadata:', e);
      }
    }

    if (readOnly) {
      return (
        <div className="manage-asset-modal manage-asset-modal--readonly">
          <div className="manage-asset-modal__readonly-content">
            <div className="manage-asset-modal__asset-container manage-asset-modal__asset-container--readonly">
              {asset && isVisible ?
              <AssetPreview
                asset={asset}
                canPlayAudio
                canPlayVideo
                height="100%"
                borderRadius={6}
                hideFileTypeIcon
                isEditAssetDetailsModal /> :

              null}
            </div>
            <div className="manage-asset-modal__readonly-footer">
              {createdByUser &&
              <Text body className="manage-asset-modal__readonly-info">
                  {`Created by ${createdByUser.firstName} ${createdByUser.lastName}`}
                  {createdAt && ` - ${this.getDate(createdAt)}`}
                </Text>}

              <DownloadAssetMenu
                asset={asset}
                id="manage-asset"
                includeOriginalQuality>

                <Button
                  prefix="download"
                  className="manage-asset-modal__readonly-download"
                  type="SECONDARY">

                  Download
                </Button>
              </DownloadAssetMenu>
            </div>
            <Text caption className="manage-asset-modal__readonly-info-size">
              {`${fileType}, ${fileSize}`}
            </Text>
          </div>
        </div>);

    }

    return (
      <div className="manage-asset-modal">
        <div className="manage-asset-modal__left-content">
          <div className="manage-asset-modal__asset-container">
            {asset && isVisible ?
            <AssetPreview
              asset={asset}
              canPlayAudio
              canPlayVideo
              height="100%"
              borderRadius={6}
              hideFileTypeIcon
              isEditAssetDetailsModal /> :

            null}
          </div>
          <div className="manage-asset-modal__updated-by-block">
            {createdByUser &&
            <Text caption>
                {`Created by ${createdByUser.firstName} ${createdByUser.lastName}`}
                {createdAt && ` - ${this.getDate(createdAt)}`}
              </Text>}

            <DownloadAssetMenu
              asset={asset}
              id="manage-asset"
              includeOriginalQuality>

              <Button
                prefix="download"
                className="manage-asset-modal__updated-by-block__download"
                type="SECONDARY">

                Download
              </Button>
            </DownloadAssetMenu>
          </div>
        </div>
        <div className="manage-asset-modal__right-content">
          <FileInfo
            filename={filename || 'N/A'}
            metaData={metaData || {}} />

          <div className="manage-asset-modal__input-container">
            <Input
              label="Title"
              validate={Boolean}
              defaultValue={title}
              placeholder="Enter title"
              onChange={this.updateInputField('title')}
              disabled={disableInput}
              labelProps={{ required: true }} />

            <Input
              label="Description"
              defaultValue={description}
              placeholder="Enter description"
              onChange={this.updateInputField('description')}
              disabled={disableInput} />

            <Input
              label="Alt Text"
              defaultValue={altText}
              placeholder="Alt text"
              onChange={this.updateInputField('altText')}
              disabled={disableInput} />

            {asset && asset.folders && asset.folders.length > 0 &&
            <div style={{ marginTop: '16px' }}>
                <Text noMargin style={{ fontSize: '12px', color: '#8c96a9', marginBottom: '6px' }}>Folders</Text>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                  {asset.folders.map((folder) =>
                <span
                  key={folder.tagId}
                  style={{
                    alignItems: 'center',
                    background: '#ebedf1',
                    borderRadius: '4px',
                    color: '#323a45',
                    display: 'inline-flex',
                    fontSize: '12px',
                    padding: '4px 10px'
                  }}>

                      {folder.label.split('/').map((seg, i, arr) =>
                  <React.Fragment key={i}>
                          {seg}
                          {i < arr.length - 1 &&
                    <span style={{ alignItems: 'center', display: 'inline-flex', margin: '0 2px' }}>
                            <Icon name="chevronright" size={8} color="regent" />
                          </span>}
                        </React.Fragment>
                  )}
                    </span>
                )}
                </div>
              </div>}

          </div>
        </div>
      </div>);

  };

  render() {
    const { modalSubtitle, isVisible, onClose, readOnly } = this.props;
    const { isLoading, error, canUpdate, asset } = this.state;

    return (
      <FormModal
        visible={isVisible}
        onClose={onClose}
        onSave={this.handleSave}
        className="form-modal__container"
        title={readOnly ? asset?.title : 'Edit Asset Details'}
        subtitle={modalSubtitle}
        hideFooter={readOnly}
        saveDisabled={!canUpdate && (Boolean(error) || isLoading || readOnly)}>

        {this.getModalContent()}
      </FormModal>);

  }
}

export default ManageAssetModal;